import { takeLatest } from 'redux-saga/effects';
import { processCallbackAction } from "@/redux/helper";
import apiConfig from "@/constants/apiConfig";
import { appConfigActionTypes } from "@/redux/actions";

const {UPDATE_VIET_GUY_CONFIG, GET_VIET_GUY_CONFIG} = appConfigActionTypes;

const getVietGuyConfig = (action) => {
    return processCallbackAction(apiConfig.appConfig.getVietGuyConfig, action);
}

const updateVietGuyConfig = (action) => {
    return processCallbackAction(apiConfig.appConfig.updateVietGuyConfig, action);
}

const appConfigSagas = [
    takeLatest(UPDATE_VIET_GUY_CONFIG, updateVietGuyConfig),
    takeLatest(GET_VIET_GUY_CONFIG, getVietGuyConfig),
]

export default appConfigSagas;